import { CircleCrossIcon, CircleIcon, CompanyLogo } from '@components/svgs';
import { CSSProperties, ReactNode } from 'react';

interface ICompetitorColumn {
  isSelected: boolean;
  cells: ReactNode[];
}

const FeatureColumn: ICompetitorColumn = {
  isSelected: false,
  cells: [
    'Features',
    'Origin / Location',
    'Recognition',
    'Rewards',
    'Gamification',
    'Wellbeing Features',
    'ESG',
  ],
};

const columnStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1.6rem',
  padding: '0 3rem',
  textAlign: 'left',
  width: '100%',
};

const titleStyle: CSSProperties = {
  flex: 1,
};

const PerksBarColumn: ICompetitorColumn = {
  isSelected: true,
  cells: [
    <CompanyLogo />,
    'Hong Kong',
    <div style={columnStyle}>
      <CircleIcon />
      <div style={titleStyle}>Recognition with voting platform</div>
    </div>,
    <div style={columnStyle}>
      <CircleIcon />
      <div style={titleStyle}>Direct integration with merchants</div>
    </div>,
    <div style={columnStyle}>
      <CircleIcon />
      <div style={titleStyle}>Minigames & Campaigns</div>
    </div>,
    <div style={columnStyle}>
      <CircleIcon />
      <div style={titleStyle}>Workshop, articles & wellness games</div>
    </div>,
    <div style={columnStyle}>
      <CircleIcon />
      <div style={titleStyle}>Recycle platform</div>
    </div>,
  ],
};

const OthersColumn: ICompetitorColumn = {
  isSelected: false,
  cells: [
    'Other Competitors',
    'Non-Local',
    <CircleIcon />,
    <CircleIcon />,
    <CircleCrossIcon />,
    <CircleCrossIcon />,
    <CircleCrossIcon />,
  ],
};

const CompetitorColumns: ICompetitorColumn[] = [FeatureColumn, PerksBarColumn, OthersColumn];

export default CompetitorColumns;
